import { Link } from "react-router-dom";
import styled from "styled-components";

/**
 * Toast body with follow-up links under the message, e.g. "Open order" after a
 * sales order is created.
 *
 * @param {{
 *   message: *,
 *   actions: !Array<{label: string, to?: string, onClick?: function()}>,
 *   closeToast?: function(),
 * }} props
 */
export const ToastWithActions = ({ message, actions, closeToast }) => (
  <div>
    <div>{message}</div>
    <ActionRow>
      {actions.map(({ label, to, onClick }) =>
        to ? (
          <Link key={label} to={to} onClick={() => closeToast?.()}>
            {label}
          </Link>
        ) : (
          <button
            key={label}
            type="button"
            onClick={() => {
              onClick?.();
              closeToast?.();
            }}
          >
            {label}
          </button>
        ),
      )}
    </ActionRow>
  </div>
);

const ActionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 6px;

  a,
  button {
    padding: 0;
    border: 0;
    background: transparent;
    color: inherit;
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
  }
`;
